import React from 'react';
import {Link} from 'react-router-dom';
import './CardInvestigaciones.css';

const Card = (props) => (
  <div className="col-md-3 fade-in course-container-investigacion">
    <div className="course-single flacso-azul">
      <Link to={{ pathname: `/investigacion/${props.id}`, state: { props } }}>
        <figure>
          <img src={props.image} alt={props.title} title={props.title} className="img-responsive img-format"/>
        </figure>
        <div className="course-content flacso-azul content-custom">
          <h3 className="" title={props.title}>{props.title}</h3>
          <p className="author" title={props.autor}>by <span>{props.autor}</span></p>
        </div>
      </Link>
    </div>
	</div>
);

export default Card;
